import { render } from "./student-referral.vue?vue&type=template&id=28408d0c"
import script from "./student-referral.vue?vue&type=script&lang=js"
export * from "./student-referral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__